import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPen, faTrash, faLock, faUnlock } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import './tabelaConsulta.css'

interface TabelaConsultaProps<T> {
  dados: T[];
  colunas: { chave: string; titulo: string; render?: (value: any, item: T) => React.ReactNode }[];
  cdEntidade: string;
  entidade: string;
  onToggleLock?: (id: number, isBlocked: boolean) => void;
  exibirIconeBloqueio?: boolean;
}

function TabelaConsulta<T>({ dados, colunas, cdEntidade, entidade, onToggleLock, exibirIconeBloqueio }: TabelaConsultaProps<any>) {
  const totalRows = 10;
  const emptyRows = totalRows - dados.length;

  const [bloqueios, setBloqueios] = useState<{ [key: number]: boolean }>({});

  const toggleBloqueio = (userId: number, isBlocked: boolean) => {
    if (onToggleLock) {
      onToggleLock(userId, !isBlocked);
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped border rounded">
        <thead>
          <tr>
            {colunas.map((coluna, index) => (
              <th key={index} className="text-center">{coluna.titulo}</th>
            ))}
            <th className="text-center">Ações</th>
          </tr>
        </thead>
        <tbody>
          {dados.map((item, rowIndex) => {
            const id = item[cdEntidade];
            const isBlocked = bloqueios[id] || item.dmBloqueado;

            return (
              <tr key={rowIndex}>
                {colunas.map((coluna, colIndex) => (
                  <td key={colIndex} style={{ width: `${100 / (colunas.length + 1)}%` }} className="text-center">
                    {item[coluna.chave as keyof typeof item]}
                  </td>
                ))}
                <td className="text-center">
                  <Link to={`/milshop/${entidade}/ver-detalhes/${id}`}>
                    <FontAwesomeIcon
                      icon={faEye}
                      className="me-2"
                      style={{ color: "var(--azul-escuro)" }}
                    />
                  </Link>
                  <Link to={`/milshop/${entidade}/alterar/${id}`}>
                    <FontAwesomeIcon
                      icon={faPen}
                      className="me-2"
                      style={{ color: "var(--azul-escuro)" }}
                    />
                  </Link>
                  <Link to={`/milshop/${entidade}/excluir/${id}`}>
                    <FontAwesomeIcon
                      icon={faTrash}
                      style={{ color: "var(--danger)" }}
                    />
                  </Link>
                  {exibirIconeBloqueio && (
                    <span className="spanIconeBloqueio" onClick={() => toggleBloqueio(id, isBlocked)} style={{ cursor: 'pointer' }}>
                      <FontAwesomeIcon
                        icon={isBlocked ? faLock : faUnlock}
                        style={{ color: isBlocked ? "var(--danger)" : 'green' }}
                      />
                    </span>
                  )}

                </td>
              </tr>
            );
          })}
          {Array.from({ length: emptyRows }, (_, rowIndex) => (
            <tr key={`empty-${rowIndex}`}>
              {colunas.map((_, colIndex) => (
                <td
                  key={colIndex}
                  style={{ width: `${100 / (colunas.length + 1)}%` }}
                  className="text-center"
                >
                  &nbsp;
                </td>
              ))}
              <td className="text-center">
                &nbsp;
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TabelaConsulta;